import { ActivatedRoute,Router } from '@angular/router';
import { ServicesService } from '../../services/services.service';
import {environment} from '../../../environments/environment';
// import swal from 'sweetalert2'; 
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-client-backorder',
  templateUrl: './client-backorder.component.html',
  styleUrls: ['./client-backorder.component.css']
})
export class ClientBackorderComponent implements OnInit {

  fields:any=[];
	listData:any=[];
	cid:string;	
	clientName:string;

	public loading = false;
  	isLoader: boolean = false;
  	public show:boolean = false;
  	apiBaseUrl = environment.apiBaseUrl;
  	spinLoader = {
    filter : false,
    delete : []
  };

  isListData=false;
  isListDataEmpty=false;
  isOnePage=true;
  backDiv=false;
  isCid=false;

  constructor(private route:ActivatedRoute, private router:Router,private _services: ServicesService) {
    this.route.queryParams.subscribe(params=>{
      this.cid = params['cid'];
    })
  }
	
  ngOnInit() {
  this._services.checkToken('status');
	if(this.cid != undefined){
    //console.log(this.cid);
      this.backDiv=true;
      this.isCid=true;
  }
	  this.fields = [
      {
        'field' : 'order_no_unique',
        'title' : 'Order Id',
        'width' : '20%',
        'code'  : true,
        'sort'  : true
      },
      {
        'field' : 'back_order_id',
        'title' : 'Back-Order Id',
        'width' : '20%',
        'code'  : false,
        'sort'  : true
      },
      {
        'field' : 'order_date',
        'title' : 'Order Date',
        'width' : '20%',
        'code'  : false,
        'sort'  : true
      },
      {
        'field' : 'order_status',
        'title' : 'Order Status',
        'width' : '20%',
        'code'  : false,
        'sort'  : true
      }
    ]
	this.getPageRequest();
  }

  resetSearchField(){
    this.searchFields=[''];
    this.getPageRequest();
  }

  getSearchRequest(){
    this.spinLoader['filter'] = true;
    this.getPageRequest();
  }

  sortType : string = '';
  sortField: string = '';
  oldField: string;
  sortingData= {
    'field' : '',
    'type'  : ''
  };

  sortBy(field, event){

    this.oldField = (this.oldField != field) ? this.oldField : field;

    if(typeof this.oldField !== 'undefined'){
      ////console.log(document.getElementById('fa-'+this.oldField));
      document.getElementById('fa-'+this.oldField).classList.remove('fa-sort-up');
      document.getElementById('fa-'+this.oldField).classList.remove('fa-sort-down');
      document.getElementById('fa-'+this.oldField).classList.add('fa-sort');
	}
	
    event.target.classList.add('fa');

    this.sortField = field;
    this.sortType = (this.sortType == 'desc') ? 'asc' : 'desc';

    switch(this.sortType){
      case 'desc' : {
        event.target.classList.remove('fa-sort-up');
        event.target.classList.add('fa-sort-down');
        this.oldField = field;
      }break;
      case 'asc'  : {
        event.target.classList.remove('fa-sort-down');
        event.target.classList.add('fa-sort-up');
        this.oldField = field;
      }break;
      default     : {
        event.target.classList.add('fa-sort');
      }
	}
	
    this.sortingData = {
      'field' : this.sortField,
      'type'  : this.sortType
		};
		
    this.getPageRequest();
  }
  /*------------------------------Table with Sorting Ends Here--------------------------*/

  /*------------------------------Pagination Integration Starts Here------------------------*/
  currentPage: number = 1;
  loader: boolean = false;
  paginate= {
    'last_page' : 1
  };
  searchFields= [];
  pages: any;
//   listData = [];
  editData: Object = {};

  previousPage(){
    if(this.currentPage == 1){
      return;
    }

    this.currentPage = this.currentPage -1;
    ////console.log(this.currentPage);return;
    this.getPageRequest();

  }

  nextPage() {

    if (this.paginate.last_page-1 < this.currentPage) {
      return;
    }

    this.currentPage ++;
    //console.log(this.currentPage);
    this.getPageRequest();
  }

  changePage(){

    this.currentPage = this.currentPage;
    ////console.log(this.currentPage);return;
    this.getPageRequest();
  }

  getPages(n){

    var data = [];

    for (var i = 1; i <= n; i++) {
      data.push(i);
    }
    this.pages = data;
  }

  /*------------------------------Pagination Integration Starts Here------------------------*/
routeData:string;
totalData:any;
  getPageRequest(){
    this.isListData=true;
    this.isListDataEmpty=false;

    let data;
    this.routeData = 'get-order-list-web';
    switch(this.routeData){
        case 'get-order-list-web':{
        data = {
            page  : this.currentPage,
            search: {
              'order_no_unique' : this.searchFields['order_no_unique'],
            },
        sort  : this.sortingData,
        client_id : this.cid
      };
      break;
      }
    }

    this.loading = true;  
    const token    = localStorage.getItem('userToken');
    this._services.requestCreator(data, this.routeData, token).subscribe((result: any) => {
      if(this._services.checkToken(result.status)){
        this.spinLoader['filter'] = false;
        this.isListData=false;
        this.listData=[{'client_name':''}];
        this.listData = result.result;
        this.totalData = result.paginate.total;
        this.currentPage = result.paginate.current_page;

        if(this.listData.length==0){
          this.isListDataEmpty=true;
        }else{
          this.cid ?this.clientName=this.listData[0].client_name:'';    
        }

        if(result.paginate.current_page > result.paginate.last_page){
        this.currentPage = result.paginate.last_page;
        }
        this.getPages(this.paginate.last_page);
      }
    });
    return true;
  }
}
